import '@adornis/adornis-components/a-swipe';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element';
import { ObservableController } from '@adornis/chemistry/controllers/observable-controller';
import { SizeController } from '@adornis/chemistry/controllers/size-controller';
import { css } from '@adornis/chemistry/directives/css';
import '@adornis/chemistry/elements/components/x-button';
import '@adornis/chemistry/elements/components/x-link';
import '@adornis/chemistry/elements/components/x-tabs';
import '@adornis/chemistry/elements/components/x-toggle-content';
import '@adornis/germanium/components/ge-accordeon';
import '@adornis/germanium/components/ge-button';
import '@adornis/germanium/components/ge-dropdown-selection';
import '@adornis/germanium/components/ge-loading-state';
import '@adornis/germanium/components/ge-section';
import '@adornis/germanium/components/ge-socialmedia-popup';
import '@adornis/germanium/components/ge-tabs';
import { Ghost, GhostData } from '@adornis/ghost/db/ghost';
import { config } from 'config.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { from, map } from 'rxjs';
import '../components/wtg-blog-post-preview';
import '../components/wtg-footer';
import '../components/wtg-forum-topic-preview';
import '../components/wtg-user-voice';

@customElement('wtg-faq')
export class WTGFAQ extends ChemistryLitElement {
  private _size = new SizeController(this);

  @state() private _posts = new ObservableController(
    this,
    from(Ghost.getAllPosts()(GhostData.allFields)).pipe(
      map(posts => posts.filter(post => post.tags.find(tag => tag.name === 'FAQ'))),
    ),
  );
  @state() private _selected?: number = 0;

  public render() {
    var selectedPosts = this._posts.value;
    const isSmall = this._size.width! < 1360;
    switch (this._selected) {
      case 0:
        selectedPosts = this._posts.value?.filter(post => post.tags.find(tag => tag.name === 'generaltopics'));
        break;
      case 1:
        selectedPosts = this._posts.value?.filter(post => post.tags.find(tag => tag.name === 'welcomebox'));
        break;
      case 2:
        selectedPosts = this._posts.value?.filter(post => post.tags.find(tag => tag.name === 'partnerservices'));
        break;
      case 3:
        selectedPosts = this._posts.value?.filter(post => post.tags.find(tag => tag.name === 'community'));
        break;
      case 4:
        selectedPosts = this._posts.value?.filter(post => post.tags.find(tag => tag.name === 'registrationandlogin'));
        break;
      default:
        break;
    }
    return html`
      <x-flex>
        <x-flex
          horizontal
          space-between
          ${css({
            paddingTop: this._size.isMobile ? '200px' : '100px',
            paddingBottom: isSmall ? '100px' : '0',
            backgroundColor: '#E7F9FF',
          })}
        >
          <x-flex space="lg" ${css({ maxWidth: this.sizes.maxReadableWidth, marginLeft: '10%' })}>
            <ge-h1>
              Frequently <br />
              Asked <br />
              Questions
            </ge-h1>
            <ge-h4> How can we help you? </ge-h4>
          </x-flex>

          <x-flex
            end
            ${css({
              width: '50%',
              minWidth: '250px',
              marginTop: '-100px',
              height: '100%',
              right: '0',
              borderBottomLeftRadius: '20%',
              display: isSmall ? 'none' : 'flex',
            })}
          >
            ${this.creativeBackdrop()}
          </x-flex>
        </x-flex>

        <ge-section>
          <x-flex crossaxis-center ${css({ width: '80%', marginLeft: 'auto', marginRight: 'auto' })}>
            <x-flex
              space-between
              space="md"
              ?horizontal=${!this._size.isMobile}
              ${css({
                backgroundColor: this.colors.secondary_500,
                color: 'white',
                alignItems: 'center',
                borderRadius: '15px',
                justifyContent: 'center',
                borderWidth: '1px',
                width: '100%',
              })}
            >
              <ge-tabs .selected=${this._selected}>
                <ge-tab @click=${() => (this._selected = 0)}> General topics </ge-tab>
                <ge-tab @click=${() => (this._selected = 1)}> Welcome Box </ge-tab>
                <ge-tab @click=${() => (this._selected = 2)}> Partner Services </ge-tab>
                <ge-tab @click=${() => (this._selected = 3)}> Community </ge-tab>
                <ge-tab @click=${() => (this._selected = 4)}> Registration and login </ge-tab>
              </ge-tabs>
            </x-flex>
            <br />

            <ge-accordeon
              ${css({ width: '100%' })}
              .items=${selectedPosts?.map(post => ({
                title: post.title,
                text: html`
                  <x-flex space="sm">
                    ${post.excerpt.split('\n').map(line => html` <ge-text> ${line} </ge-text> `)}
                  </x-flex>
                `,
              })) ?? []}
            >
            </ge-accordeon>
          </x-flex>
          <br /><br /><br />
        </ge-section>

        <x-flex
          margin="${this._size.isMobile ? 'md' : 'xxl'}"
          ?horizontal=${!this._size.isMobile}
          end
          ${css({
            background: `linear-gradient(${this._size.isMobile ? '195deg' : '105deg'}, transparent 20%, ${
              this.colors.accent
            } 40%), url(${require('client/assets/faq_images/threewomen.png')})`,
            borderRadius: this.sizes.borderRadius,
            color: this.colors.on.accent,
          })}
        >
          <x-flex
            space="lg"
            center
            ${css({
              width: this._size.isMobile ? '100%' : '50%',
              // height: this.size.isMobile ? '50%' : '100%',
              padding: this._size.isMobile ? this.spacing.sm : '',
              height: '400px',
              position: 'relative',
            })}
          >
            <ge-h2> You have more </ge-h2>
            <ge-h2> questions? </ge-h2>
            <ge-text> We would be happy to answer you </ge-text>
            <ge-button
              ${css({ color: 'white', borderColor: 'white', alignSelf: 'start' })}
              mode="outline"
              icon="east"
              iconend
              href="mailto:${config.get('ADMIN_MAIL')}"
            >
              CONTACT US
            </ge-button>
            <img
              ${css({
                position: 'absolute',
                bottom: '-30px',
                right: '10%',
                display: this._size.isMobile ? 'none' : 'flex',
              })}
              src=${require('client/assets/faq_images/Patternimroten.png')}
            />
          </x-flex>
        </x-flex>
        <wtg-footer></wtg-footer>
      </x-flex>
    `;
  }

  private creativeBackdrop() {
    const isSmall = this._size.width! < 1360;
    return html`
      <div
        ${css({
          width: isSmall ? '30%' : '100%',
          height: '50%',
          display: 'grid',
          top: '0',
          left: '0',
          right: '0',
          // alignItems: 'end',

          gridTemplateAreas: `
            "a . . . . f"
            "g g e d . ."
            "g g . c . ."
          `,
        })}
      >
        <x-flex crossaxis-end ${css({ gridArea: 'a', overflow: 'visible' })}>
          <img
            ${css({
              paddingTop: '50px',
              width: '72px',
              height: '144px',
            })}
            src=${require('client/assets/faq_images/Half_Circle_1.png' /* yellow */)}
          />
        </x-flex>

        <x-flex
          crossaxis-end
          ${css({
            gridArea: 'g',
            overflow: 'visible',
            position: 'relative',
            display: 'flex',
          })}
        >
          <img
            ${css({ position: 'absolute', top: '75px', right: '30px' })}
            src=${require('client/assets/faq_images/Pattern.png')}
          />
          <img ${css({ zIndex: '1' })} src=${require('client/assets/faq_images/woman.png')} />
          <!-- frau -->
        </x-flex>
        <x-flex end crossaxis-end ${css({ gridArea: 'd', overflow: 'visible', display: 'flex' })}>
          <!-- area d leer Typ mit glatze -->
        </x-flex>
        <x-flex end crossaxis-end ${css({ gridArea: 'f', overflow: 'visible', display: 'flex' })}>
          <img height="72px" width="95px" src=${require('client/assets/faq_images/Half_Circle_2.png' /* green */)} />
        </x-flex>

        <x-flex crossaxis-end ${css({ gridArea: 'e', overflow: 'visible', display: 'flex' })}>
          <img width="115px" height="115px" src=${require('client/assets/faq_images/Dots.png')} />
        </x-flex>
        <x-flex crossaxis-end end ${css({ gridArea: 'c', overflow: 'visible', position: 'relative' })}>
          <img
            height="144px"
            width="72px"
            src=${require('client/assets/faq_images/Half_Circle_3.png' /* blue */)}
            ${css({ position: 'absolute', bottom: '-40px' })}
          />
        </x-flex>
      </div>
    `;
  }
}
